import { Grid } from "@mui/material"
import { StyledButtonGroupSwitch, StyledButtonSwitch } from "../ButtonSwitch/ButtonSwitch"

interface SwitchOption {
  view: string
  setView: (data: string) => void
  viewList: ViewData[]
  noGrid?: boolean
  disabled?: boolean
}

export interface ViewData {
  value: string
  label: string
}

export const ViewToggler = ({ view, setView, viewList, noGrid, disabled }: SwitchOption) => {

  const content = (
    <StyledButtonGroupSwitch disabled={disabled}  >
      {viewList.map((viewSwitch: ViewData) => (
        <StyledButtonSwitch
          key={viewSwitch.value}
          onClick={() => setView(viewSwitch.value)}
          active={view === viewSwitch.value}
        >
          {viewSwitch.label}
        </StyledButtonSwitch>
      ))}
    </StyledButtonGroupSwitch>
  )

  return noGrid ? (
    <div>{content}</div>
  ) : (
    <Grid container sx={{ width: "auto" }} flexDirection={"row-reverse"}>
      {content}
    </Grid>
  )
}
